import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 4.5rem;
	min-height: 4.5rem;

	body[dir='rtl'] & {
		height: 5.5rem;
		min-height: 5.5rem;
	}
`;
